import { filterData } from "../../api/common";






const ListarClientes = async() => {

    try {
        const clientesDB = await filterData("usuarios",[ // Body para la consuta aggregate de mongo para metrologos y que esten activos.
            {
              "$lookup": {
                "from": "roles",
                "localField": "role",
                "foreignField": "_id",
                "as": "result"
              }
            },
            {
              "$match": {
                "result.nombre":"Cliente"
              }
            }
          ]);
          console.log('clientes: ', clientesDB)
  return (clientesDB)
        
    } catch (error) {
        
    }

}

export default ListarClientes;

